import React from 'react'
import {useIntl} from 'react-intl'
import {Button, Text} from '@chakra-ui/react3'
import {MultiColorIcon} from '../../../../../leap/components/icons'

const OpenConfiguratorBtn = (props) => {
    const {formatMessage} = useIntl()
    const openConfiguratorLabel = formatMessage({
        id: 'product_detail.cta.customize',
        defaultMessage: 'Customize'
    })

    return (
        <Button
            variant="secondaryGhost"
            width="fillContent"
            size="lg"
            aria-label={openConfiguratorLabel}
            {...props}
        >
            <Text>{openConfiguratorLabel}</Text>
            <MultiColorIcon />
        </Button>
    )
}

export default OpenConfiguratorBtn
